import PsychologicalAppointmentPage from './PsychologistAppointmentPage';
export default PsychologicalAppointmentPage;